/**
 * Accepts a string and returns a string with all inline superscript indicators replaced with <sup> tags
 * E.g. hello world^2 becomes hello world<sup>2</sup>
 */
export const replaceForSuperScript = (text: string) => {
    return text.replace(
        /(\^\d+)/g,
        (i, match) => `<sup>${match.replace('^', '')}</sup>`
    )
}
